import Class from './c-month-list';
import './c-month-list@';

export default Class;